{
    "Presence_Page_Title": "Aanwezigheid",
    "Presence_SortBy_Title": "Sorteren op:",
    "Presence_SortBy_Options_FullName_ASC": "Volledige naam (A-Z)",
    "Presence_SortBy_Options_FullName_DSC": "Volledige naam (Z-A)",
    "Presence_Search_Title": "Zoek op",
    "Presence_Filter_Title": "Meer filters",
    "Presence_MoreFilters_Title": "Filter op:",
    "Presence_MoreFilters_Options_Department": "Afdeling",
    "Presence_MoreFilters_Options_Queue": "Wachtrij",
    "Presence_Filter_Availability_All": "Alle",
    "Presence_Filter_Availability_Available": "Beschikbaar",
    "Presence_Filter_Availability_Busy": "Druk",
    "Presence_Filter_Availability_Away": "Weg",
    "Presence_Filter_Availability_Offline": "Offline",
    "Presence_Filter_Availability_OutOfOffice": "Buiten kantoor",
    "Presence_Filter_Availability_DoNotDisturb": "Niet storen",
    "Presence_Filter_Availability_BeRightBack": "Ben zo terug",
    "Presence_Activity_Available_Title": "Beschikbaar",
    "Presence_Activity_Away_Title": "Weg",
    "Presence_Activity_BeRightBack_Title": "Ben zo terug",
    "Presence_Activity_Busy_Title": "Druk",
    "Presence_Activity_DoNotDisturb_Title": "Niet storen",
    "Presence_Activity_InAcall_Title": "In een gesprek",
    "Presence_Activity_InAConferenceCall_Title": "In een telefonische vergadering",
    "Presence_Activity_Inactive_Title": "Inactief",
    "Presence_Activity_InAMeeting_Title": "In een vergadering",
    "Presence_Activity_Offline_Title": "Offline",
    "Presence_Activity_OffWork_Title": "Buiten het werk",
    "Presence_Activity_OutOfOffice_Title": "Buiten kantoor",
    "Presence_Activity_PresenceUnknown_Title": "Aanwezigheid Onbekend",
    "Presence_Activity_Presenting_Title": "presenteren",
    "Presence_Activity_UrgentInterruptionsOnly_Title": "Alleen dringende onderbrekingen",
    "Presence_NoUsers": "Er zijn geen gebruikers beschikbaar voor je huidige filter",
    "NAME": "Presence",
    "Presence_Activity_InACall_Title": "In een gesprek",
    "Presence_SearchQuery_TooLong": "Zoeken is te lang"
}